import { zodResolver } from "@hookform/resolvers/zod";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input } from "../../../../../assets/styles/Input";
import { Button } from "../../../../../components/Button/button";
import { Modal } from "../../../../../components/Modal";
import { ModalEditRegsterStyled } from "../../../../../components/Modal/ModalEditRegister/styles";
import { UserContext } from "../../../../../providers/UserContext";
import { iEdit, usersUpdateSchema } from "../../FormSchema/edit.schema";
import { api } from "../../../../../api/api";
import { Select } from "../../../../../components/Select";

export const ModalEdit = ({ showEdit, setShowEdit }: any) => {
	const { user, editPerfil } = useContext(UserContext);

	const [icons, setIcons] = useState<any[] | []>([]);

	const options = icons.map((icon: any, i: number) => {
		if (
			icon.url ===
				"http://res.cloudinary.com/ddhbhbxcs/image/upload/v1718592759/wnlma7becyaqr2prhsga.svg" &&
			user?.role === "admin"
		) {
			return { value: icon.url, name: icon.name };
		}
		if (
			icon.url !==
			"http://res.cloudinary.com/ddhbhbxcs/image/upload/v1718592759/wnlma7becyaqr2prhsga.svg"
		) {
			return { value: icon.url, name: icon.name };
		}
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
	} = useForm<iEdit>({ resolver: zodResolver(usersUpdateSchema) });

	const submitEdit = (editData: iEdit) => {
		editPerfil(editData);
		setShowEdit(false);
	};

	useEffect(() => {
		const getAllIcons = async () => {
			const response = await api.get("/icon");

			setIcons(response.data);
		};

		getAllIcons();
	}, []);

	return (
		<ModalEditRegsterStyled>
			{showEdit && (
				<Modal showModal={setShowEdit}>
					<div className="card">
						<h1>Editar</h1>
						<div className="form">
							<form method="post" onSubmit={handleSubmit(submitEdit)}>
								<Input
									type="text"
									{...register("name")}
									id="name"
									placeholder="Nome"
									defaultValue={user?.name}
									alt="Nome"
								/>
								{errors.name && <span>{errors.name.message}</span>}

								<Input
									type="text"
									{...register("username")}
									id="username"
									placeholder="Username"
									defaultValue={user?.username}
									alt="Username"
								/>
								{errors.username && <span>{errors.username.message}</span>}

								<Input
									type="text"
									{...register("bio")}
									id="bio"
									placeholder="Bio"
									defaultValue={user?.bio}
									alt="bio"
								/>
								{errors.bio && <span>{errors.bio.message}</span>}

								<Select
									name="icon"
									id="icon"
									placeholder="Escolha uma opção"
									setValue={setValue}
									attribute={"icon"}
									options={options}
									register={register}
									alt="Icone"
								/>

								<Button type="submit">Editar</Button>
							</form>
						</div>
					</div>
				</Modal>
			)}
		</ModalEditRegsterStyled>
	);
};
